
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply component specific CSS */
.tufts-main-header{border-top:1.625rem solid var(--dark-blue)}.tufts-main-header.mobile{border-top:1.25rem solid var(--dark-blue)}.top-header{border:0;height:auto}[cloned-slot-name=header-logo] img{max-width:250px}[cloned-slot-name=header-cta]{align-items:center;display:flex;flex-wrap:wrap;gap:1rem}[cloned-slot-name=header-cta-mobile] tufts-button,[cloned-slot-name=header-cta] tufts-button{--tufts-btn-gap:0.5rem}.mobile [cloned-slot-name=header-logo] img{max-width:180px}.mobile .top-header{display:flex;flex-wrap:wrap;place-content:space-between;place-items:center}`;